import Grid from "@mui/material/Grid";
import { Box, Stack } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostAppliedSingleValueGolden } from "./components/basic/BasicPostApplied";
import { BasicDetailGolden } from "./components/basic/BasicDetail";
import {
  BasicExperience,
  BasicExperienceGolden,
} from "./components/basic/BasicExperience";
import {
  BasicPassport,
  BasicPassportGolden,
} from "./components/basic/BasicPassport";
import { BasicFullNameGolden } from "./components/basic/BasicFullName";
import { BasicFace, BasicFaceNoBorder } from "./components/basic/BasicFace";
import { BasicStand, BasicStandNoBorder } from "./components/basic/BasicStand";
import {
  BasicReferenceOnlyEnglish,
  BasicReferenceOnlyEnglishGolden,
} from "./components/basic/BasicReference";
import { BasicPassportScan } from "./components/basic/BasicPassportScan";
import {
  BasicHeader,
  BasicHeaderNoBorder,
} from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";
import { BasicFooter } from "./components/basic/BasicFooter";
import { useTranslation } from "react-i18next";
import {
  BasicSkillsOneLineHorz,
  BasicSkillsVer,
  BasicSkillsVerGolden,
  BasicSkillsVerValue,
} from "./components/basic/BasicSkills";
import { BasicCountryHorz } from "./components/basic/BasicFlag";

// 704a66 header background
// dbdbdb even row color
interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
function GoldenTemplate({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  const { t: tt } = useTranslation();
  const { t: te } = useTranslation("enums");

  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeaderNoBorder
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          {/* <Grid item xs={12}>
            <BasicTitleSingleLang template={cvTemplate} />
          </Grid> */}
          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={3}></Grid>
            <Grid item xs={6}>
              <BasicReferenceOnlyEnglishGolden
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid container item xs={9}>
              {/* <Stack spacing={cvTemplate.spacing} sx={{ width: "100%" }}>
              </Stack> */}
              <Grid item xs={12}>
                {cvTemplate && currentEmployee && (
                  <BasicPostAppliedSingleValueGolden
                    currentEmployee={currentEmployee}
                    template={{ ...cvTemplate, showCellBorders: true }}
                  />
                )}
              </Grid>
            </Grid>
            {/* Short Photo */}
            <Grid item xs={3}>
              {cvTemplate && currentEmployee && (
                <BasicFaceNoBorder
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Grid>
          </Grid>

          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            sx={{ backgroundColor: cvTemplate.headBgColor, p: 2, mt: 1 }}
          >
            <Grid item md={5} xs={12}>
              {cvTemplate && currentEmployee && (
                <Stack
                  spacing={cvTemplate.spacing}
                  sx={{
                    alignItems: "center",
                  }}
                >
                  <BasicStandNoBorder
                    currentEmployee={currentEmployee}
                    template={cvTemplate}
                  />
                </Stack>
              )}
            </Grid>
            <Grid item md={7} xs={12}>
              {cvTemplate && currentEmployee && (
                <>
                  <BasicDetailGolden
                    currentEmployee={currentEmployee}
                    template={{
                      ...cvTemplate,
                      showCellBorders: true,
                      cellBorderBottomOnly: true,
                    }}
                    showHeader={true}
                    showReference={false}
                    showNationality={true}
                    showPassportNumber={false}
                    showReligion={true}
                    showDateOfBirth={true}
                    showAge={false}
                    showPlaceOfBirth={true}
                    showMaritalStatus={true}
                    showNumberOfChildren={true}
                    showWeightHeight={true}
                    showComplexion={false}
                    showEducation={true}
                    showLivingTown={false}
                    showEmployeeTelephone={false}
                    showContactName={false}
                    showContactTelephone={false}
                  />
                  <BasicPassportGolden
                    currentEmployee={currentEmployee}
                    template={{
                      ...cvTemplate,
                      showCellBorders: true,
                      cellBorderBottomOnly: true,
                    }}
                    showHeader={true}
                    showPassportNumber={true}
                    showIssueDate={true}
                    showPlaceOfIssue={true}
                    showExpiryDate={true}
                  />
                </>
              )}
            </Grid>
          </Grid>
          <Grid item md={5} xs={12} sx={{ mt: 1 }}>
            <BasicExperience
              currentEmployee={currentEmployee}
              template={{ ...cvTemplate, showCellBorders: true }}
              type="basic"
            />
          </Grid>
          <Grid item md={7} xs={12}>
            <BasicSkillsVerGolden
              currentEmployee={currentEmployee}
              template={{ ...cvTemplate, showCellBorders: true }}
            />
          </Grid>
        </Grid>
      </Box>
      {cvTemplate.numberOfPages === 2 && (
        <Stack
          id="passportData"
          sx={{
            p: 1,
            pt: 1,
            backgroundColor: backgroundColor,
            minHeight: "1500px",
          }}
        >
          {cvTemplate.addPassportHeader && (
            <Box
              sx={{
                height: "90%",
              }}
            >
              {cvTemplate && currentEmployee && (
                <BasicHeaderNoBorder
                  selectedCompany={selectedCompany}
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Box>
          )}
          {cvTemplate && currentEmployee && (
            <Box
              sx={{
                mt: 15,
              }}
            >
              <BasicPassportScan
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            </Box>
          )}
        </Stack>
      )}
    </>
  );
}

export default GoldenTemplate;
